import { IOffer } from '../../../store/offerHistory';

export interface IOfferRowProps {
  selectable?: boolean;
  onClick(): void;
  data: IOffer;
  isActive: boolean;
  isViewed: boolean;
  testId?: string;
}

export interface IOffersFeedProps {
  scrollable?: boolean;
  selectable?: boolean;
  data: IOffer[];
  onOfferClick(offerId: number): void;
  showMoreBtn?: React.ReactElement;
  activeOfferId?: number | null;
  viewedOffers: number[];
  feedViewState: [boolean, (isNarrow: boolean) => void];
}

export interface INearbyHousesInfoData {
  features: TFeatures;
}

export type TFeatures = Array<{ title: string; value: string }>;

export enum EPriceDiff {
  Decrease = 'decrease',
  Increase = 'increase',
  NoChange = 'noChange',
}

export enum EStatus {
  Deactivated = 'deactivated',
  Published = 'published',
}
